$('.js-menu-toggle').on('click', function(){
          $(this).toggleClass('is-active');
          $('.c-mnav').toggleClass('is-active');
});

$('.c-mnav-button').on('click', function(){
          $(this).toggleClass('is-active');
          $('.c-mnav__top-lvl').toggleClass('c-mnav__top-lvl--is-active');
          $('.c-mnav__indicator').removeClass('is-active');
});
$(".c-nav__item--is-parent").hover(function() {
    $('.c-nav__overlay').addClass("c-nav__overlay--is-active");
});
$(".c-nav").hover(function() {}, function() {
    $('.c-nav__overlay').removeClass("c-nav__overlay--is-active");
});
$('.c-mnav__indicator').on('click', function(){
          $(this).toggleClass('is-active');
});
